<template>
	<div class="version-detail">
		<div @click="closeDetail" id="close_order" class="pro-dt-close"></div>
		<!-- 帐号或登录 -->
		<div class="block">
			<div class="block-left">{{ getConstants('PRICING_NEW_ACCOUNT') }}:</div>
			<div class="block-right">
				<span v-html="PageInfo.user_name"></span>
			</div>
		</div>
		<!-- 当前版本 -->
		<div class="block">
			<div class="block-left">
				{{ getConstants('PRICING_NEW_DETAIL_CURRENT_VERSION') }}:
			</div>
			<div class="block-right">
				<span>{{ currentVersionText }}</span>
				<span v-if="!isUserFree">
					<span
						>（
						{{ getConstants('PRICING_NEW_DETAIL_EXPRIED_TIME') }} &nbsp;</span
					>
					<span :style="isUserExpired ? 'color: #ff5252;' : ''">{{
						expiresTime
					}}</span
					>)
				</span>
			</div>
		</div>
		<!--版本选择 -->
		<div class="block eagle">
			<div class="block-left">
				{{ getConstants('PRICING_NEW_DETAIL_SELECT_TIME') }}:
			</div>
			<div class="block-right">
				<div class="select-eagle">
					<div class="select-eagle-title">
						{{ getConstants('PRICING_NEW_EAGLE_SELECT_TITLE') }}
					</div>
					<div class="select-eagle-detail">
						<p>
							{{ versionText.planVersion }}
							<span style="margin-left: 6px;">{{
								versionText.planOrigin
							}}</span>
						</p>
						<p>
							{{ getConstants('PRICING_NEW_EAGLE_SELECT_LICENCE') }}
							<span style="margin-left: 6px;">{{
								getConstants('PRICING_NEW_EAGLE_SELECT_ORIGIN_PRICE_199')
							}}</span>
						</p>
					</div>
					<div class="select-eagle-price">
						<p class="price-time">
							{{ getConstants('PRICING_NEW_EAGLE_SELECT_ORIGIN_SPECIAL') }}
						</p>
						<h3 class="price-money">
							¥
							<span>{{ price.toFixed(2) }}</span>
						</h3>
					</div>
					<i class="psprite psprite-selected"></i>
				</div>
				<div class="select-tip">
					{{ getConstants('PRICING_NEW_EAGLE_SELECT_TIP') }}
				</div>
			</div>
		</div>
		<!-- 年付特权 -->

		<div class="block">
			<div class="block-left">
				{{ getConstants('PRICING_NEW_DETAIL_YEAR_RIGHT') }}：
			</div>
			<div class="block-right privilige">
				<p>{{ saveText }}</p>
				<p>{{ priviligeText }}</p>
				<p v-if="isUserExpired" class="add-fee">
					<span>{{ getConstants('PRICING_NEW_DETAIL_ADDED_FEE') }}</span>
					<a href="http://www.jianguoyun.com/s/help/?p=1366" class="cube"></a>
				</p>
			</div>
		</div>

		<!-- 总空间 -->
		<div class="block">
			<div class="block-left">
				{{ getConstants('PRICING_NEW_DETAIL_TOTAL_STORAGE') }}:
			</div>
			<div class="block-right">
				{{ planData.storage
				}}{{
					PageInfo.storageQuota &&
						` (${getConstants(
							'PRICING_NEW_DETAIL_CURRENT_STORAGE',
						)}${getConstants('COLON')}${PageInfo.storageQuota})`
				}}
			</div>
		</div>
		<!-- 充值后有效期 -->
		<div class="block">
			<div class="block-left">
				{{ getConstants('PRICING_NEW_DETAIL_EXPRIED') }}:
			</div>
			<div class="block-right charge">
				<span class="fl-l">{{ expiresTimeAfterPay }}</span>
			</div>
		</div>
		<!-- 支付 -->
		<div class="pay-box clearfix">
			<div class="pay-box-button not-allowed" v-if="isPaidInvalid">
				<span>{{ getConstants('PRICING_NEW_DETAIL_NOT_ALLOW') }}</span>
			</div>
			<div v-else id="pay_ali" @click="payNow" class="pay-box-button">
				<span>{{ getConstants('PRICING_NEW_DETAIL_PAY') }}</span>
				<span>¥ {{ price.toFixed(2) }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import { versionText } from '../AppSale/versionText.js'

import { getVersion } from '../../../../utils/accountHelper'
import {
	getVersionSelected,
	isUserFree,
	isUserExpired,
	getIfPaidInvalid,
} from '../../../../utils/detailHelper'

import { formatDate } from '../../../../utils/formate'

export default {
	data() {
		return {
			timeType: 12,
			giftNum: 0,
			giftType: '',
		}
	},
	props: {
		price: {
			type: Number,
			required: true,
		},
		version: {
			type: String,
		},
		coupon: {
			type: Object,
			default: () => ({}),
		},
		planData: {
			type: Object,
		},
	},
	computed: {
		versionText() {
			return versionText[this.version]
		},
		isUserFree() {
			return Number(PageInfo.accountState) === 1 || !PageInfo.accountState
		},
		// 用户是否过期--- 付费用户
		isUserExpired() {
			return isUserExpired(PageInfo.accountState, PageInfo.expireDate)
		},
		// 过期时间
		expiresTime() {
			return formatDate(PageInfo.expireDate)
		},
		// 支付后过期时间
		expiresTimeAfterPay() {
			return formatDate(this.planData.expried)
		},
		// 但前选择版本数据
		currentVersion() {
			return getVersionSelected(this.version, this.timeType)
		},
		// 版本名称
		currentVersionText() {
			return this.getConstants(getVersion(PageInfo.accountState))
		},
		// 年付特权
		priviligeText() {
			const versionSelected = getVersionSelected(this.version)
			return (
				this.getConstants(versionSelected.name) +
				' ' +
				this.getConstants('PRICING_NEW_DETAIL_ADDED_STORAGE').replace(
					'%s',
					this.planData.added,
				)
			)
		},
		// 当前价格/节省费用
		saveText() {
			return this.getConstants(this.planData.saveText)
		},
		//
		isAddedFeeVisiable() {
			// 非免费版 + 过期 +
			return (
				!isUserFree(PageInfo.accountState) &&
				PageInfo.expireDate < new Date().getTime()
			)
		},
		isPaidInvalid() {
			return getIfPaidInvalid({
				coupon: this.coupon,
				version: this.version,
				timeType: 12,
			})
		},
	},
	methods: {
		closeDetail() {
			this.$emit('closeDetail')
		},

		payNow() {
			let url =
				'/d/newOrder?month=' +
				this.planData.times +
				'&service_plan=' +
				this.currentVersion.plan

			if (this.coupon && this.coupon.coupon_code) {
				url += '&coupon_code=' + this.coupon.coupon_code
			}
			if (!this.PageInfo.user_name) {
				location.href = '/d/login?next=' + encodeURIComponent(url)
			} else {
				location.href = url
			}
		},
		selectTime(timeType) {
			this.timeType = timeType
		},
	},
}
</script>
<style lang="scss" scoped>
.block.eagle {
	.select-eagle {
		position: relative;
		max-width: 472px;
		height: 100px;
		padding-left: 24px;
		border: solid 2px #299bff;
		background: url('../../images/svg/eagle_plan_bg.svg') left bottom/44px 49px
			no-repeat;
		.psprite-selected {
			position: absolute;
			display: block;
			background: url('../../images/svg/plan-selected.svg') 1px 1px/28px 28px
				no-repeat;
			right: 0;
			bottom: 0;
			width: 28px;
			height: 28px;
		}
	}
	.select-eagle-price {
		position: absolute;
		right: 18px;
		top: 18px;
		text-align: right;

		.price-time {
			font-size: 12px;
			line-height: 18px;
			color: #4bb490;
		}
		.price-money {
			font-size: 32px;
			line-height: 48px;
			color: #299bff;
			font-weight: 500;
		}
	}
	.select-eagle-title {
		padding-top: 12px;
		padding-bottom: 6px;
		font-size: 18px;
		line-height: 28px;
		color: #299bff;
	}
	.select-eagle-detail {
		font-size: 14px;
		line-height: 20px;
		padding-bottom: 2px;
		span {
			color: #b9c8d5;
		}
	}
	.select-tip {
		margin-top: 4px;
		line-height: 18px;
		font-size: 12px;
		word-wrap: break-word;
		color: #5fb4ff;
		max-width: 500px;
	}
}

.version-detail {
	padding: 30px 44px 24px 44px;
	font-size: 14px;
	text-align: left;
	position: relative;
	.block {
		display: flex;
		padding-bottom: 20px;
		.block-left {
			width: 80px;
			margin-right: 20px;
		}
		.charge {
			span {
				line-height: 20px;
			}
			.cube {
				margin-left: 5px;
				height: 20px;
				width: 16px;
				img {
					margin-top: 2px;
				}
			}
			.charge-extra {
				color: #ff5252;
				cursor: pointer;
			}
		}
	}

	.pay-box-button {
		width: 320px;
		margin: 0 auto;
		line-height: 48px;
		border-radius: 4px;
		box-shadow: 0 3px 6px 0 rgba(0, 112, 211, 0.25);
		background-color: $blue;
		text-align: center;
		font-size: 18px;
		color: #fff;
		cursor: pointer;
		&.not-allowed {
			box-shadow: none;
			background-color: #909090;
			cursor: not-allowed;
		}
	}
}

.pro-dt-close {
	position: absolute;
	height: 16px;
	width: 16px;
	background: url('../../images/svg/close.svg') 0 0/16px 16px no-repeat;
	right: 20px;
	top: 20px;
	cursor: pointer;
}
.version-detail.show {
	opacity: 1;
	filter: opacity(100);
}
.tap-option.detail {
	margin-top: 0;
	margin-left: -528px;
	width: 320px;
	height: 1020px;
}
</style>
